<template>
  <div class="card" style="margin-top: 11vh; height: 21em; width: 18rem">
    <div class="card-body Quicksand">
      <h5
        v-on:click="moreInfoPopup"
        class="card-title"
        style="font-weight: bold"
      >
        {{ title }} <b-icon icon="arrows-angle-expand"></b-icon>
      </h5>
      <p class="card-text" style="margin-top: 2em">{{ body }}</p>
      <p class="card-text">${{ price }}</p>

      <div style="margin-left: 1em; align-items: left; text-align: left">
        <b-icon
          :icon="showCoupon ? 'caret-down-fill' : 'caret-right-fill'"
          v-on:click="CouponDisplay"
        ></b-icon>
        <span class="card-text"> coupon</span>
      </div>
      <div class="row" v-if="showCoupon">
        <input v-model="coupon" class="col" placeholder="coupon" />
        <div class="col">
          <button class="button btn-filled-black" v-on:click="EnteredCoupon">
            Enter
          </button>
        </div>
      </div>
      <div class="row" style="width: 10em">
        <a
          href="/#/book"
          :style="orderbtn"
          v-on:click="ButtonClicked(id, price, time, description)"
          ><button class="button btn-outlined">
            Book now <b-icon icon="arrow-right"></b-icon></button
        ></a>
      </div>
      <vue-modaltor
        :visible="popupOpen"
        @hide="popupOpen = false"
        :resize-width="{ 1200: '60%', 992: '80%', 768: '90%' }"
      >
        <h5 style="text-align: center">
          {{ title }}
        </h5>
        <hr />
        <p v-html="popupData">
          <!-- {{ popupData }} -->
        </p>
      </vue-modaltor>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
const axios = require("axios");

export default {
  name: "Card",
  data() {
    return {
      showCoupon: false,
      margin: 2,
      coupon: "",
      usedCoupon: false,
      popupOpen: false,
    };
  },
  computed: {
    orderbtn() {
      return {
        "margin-top": `${this.margin}em`, //can also place in css
      };
    },
  },
  props: {
    id: String,
    title: String,
    body: String,
    price: Number,
    time: String,
    description: String,
    popupData: String,
  },
  methods: {
    ...mapActions({
      UpdateWantedProgram: "UpdateWantedProgram",
    }),
    moreInfoPopup() {
      this.popupOpen = true;
    },
    makeToast(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
    EnteredCoupon() {
      let data = {
        coupon: this.coupon,
      };

      if (!this.usedCoupon) {
        axios
          .get(
            "https://us-central1-shani-life-coaching.cloudfunctions.net/getCouponById",
            {
              params: {
                coupon: data,
              },
            }
          )
          .then((response) => {
            if (response.data.amount_off != null) {
              this.makeToast(
                "Success",
                "$ " + response.data.amount_off / 100 + " Off!",
                "success"
              );
              this.price -= parseFloat(response.data.amount_off / 100);
              this.usedCoupon = true;
            } else {
              if (response.data.percent_off != null) {
                let left = Math.floor(
                  this.price * ((100 - response.data.percent_off) / 100.0)
                );
                this.makeToast(
                  "Success",
                  `% ${response.data.percent_off} Off! Saved: $ ${
                    this.price - left
                  }`,
                  "success"
                );
                this.price = left;
                this.usedCoupon = true;
              } else if (response.data.code == "resource_missing") {
                this.makeToast(
                  "Error",
                  "No such coupon: " + this.coupon,
                  "danger"
                );
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.makeToast(
              "Error",
              "An error occurred while trying to check coupon, Please try again later...",
              "danger"
            );
          });
      } else {
        this.makeToast("Error", "You can't use multiple coupons!", "danger");
      }
    },
    ButtonClicked(id, price, time, description) {
      this.UpdateWantedProgram({
        id: id,
        Price: price,
        Time: time,
        description: description,
      });
    },
    CouponDisplay() {
      this.showCoupon = !this.showCoupon;
      if (this.margin == 1) this.margin = 2;
      else {
        if (this.margin == 2) this.margin = 1;
      }
    },
  },
};
</script>

<style lang="scss">
.Quicksand {
  font-family: Quicksand;
}
</style>
